// Hodnocení obchodu — oficiální hodnocení ze Shoptetu (/hodnoceni-obchodu/),
// jen s textem, nejnovější, beze změn textu. Statický obal je v administraci.
const MYREFERENCES_URL = "/cache/hodnoceni-obchodu/";
const MYREFERENCES_CACHE_KEY = "myreferences-v1";
const MYREFERENCES_CACHE_TTL = 30 * 60 * 1000;
const MYREFERENCES_MAX = 8;

function myReferencesStars(count) {
    let html = "";
    for (let i = 1; i <= 5; i++) {
        html += "<span class='star " + (i <= count ? "star-on" : "star-off") + "' aria-hidden='true'></span>";
    }
    return html;
}
// Počet hodnocení se vždy ukazuje jako „99+“ („30 hodnocení“ → „99+ hodnocení“), přání klienta
// Počet hodnocení nad 99 se zkracuje na „99+“ („1 234 hodnocení“ → „99+ hodnocení“)
function myReferencesCount(text) {
    const match = String(text).match(/^([\d\s\u00a0]+)(.*)$/);
    if (!match) {
        return text;
    }
    return ("99+ " + match[2].trim()).trim();
}

function myReferencesParse(html) {
    const $page = $($.parseHTML(html));
    const data = {
        average: $page.find(".rate-average").first().text().trim(),
        averageStars: $page.find(".rate-average-inner .star-on").length,
        count: $page.find(".rate-average-inner .stars-label").first().text().trim(),
        votes: [],
    };

    $page.find("#ratingsList .vote-wrap").each(function () {
        const $vote = $(this);
        const text = $vote.children(".vote-content").text().trim();

        if (text.length === 0 || data.votes.length >= MYREFERENCES_MAX) {
            return;
        }

        data.votes.push({
            initials: $vote.find(".vote-initials").first().text().trim(),
            name: $vote.find(".vote-name").first().text().trim(),
            date: $vote.find(".vote-time").first().text().trim().replace(/\./g, ". ").trim(),
            stars: $vote.find(".vote-rating .star-on").length,
            text: text,
        });
    });

    return data;
}

function myReferencesRender($block, data) {
    // Starý obsah z administrace s ručně psanými texty se nesmí zobrazit
    $block.find(".whole-wrap").remove();

    if (!data || !data.count) {
        $block.addClass("is-empty");
        return;
    }

    const $summary = $("<div class='myreferences-summary'></div>");
    $("<strong class='myreferences-average'></strong>").text(data.average).appendTo($summary);
    $("<span class='myreferences-stars stars'></span>").html(myReferencesStars(data.averageStars)).appendTo($summary);
    $("<span class='myreferences-count'></span>").text(myReferencesCount(data.count)).appendTo($summary);
    $summary.appendTo($block.find(".myreferences-title"));

    if (data.votes.length === 0) {
        $block.addClass("no-votes");
        return;
    }

    const $wrapper = $("<div class='swiper-wrapper'></div>");

    data.votes.forEach(function (vote) {
        const $slide = $("<div class='myreference swiper-slide'></div>");

        $("<div class='myreference-initials'><span></span></div>").find("span").text(vote.initials).end().appendTo($slide);
        $("<div class='myreference-rating stars'></div>").html(myReferencesStars(vote.stars)).appendTo($slide);
        $("<div class='myreference-text'></div>").text(vote.text).appendTo($slide);
        $("<div class='myreference-name'></div>").text(vote.name).appendTo($slide);
        $("<div class='myreference-date'></div>").text(vote.date).appendTo($slide);

        $slide.appendTo($wrapper);
    });

    const $slider = $("<div class='whole-wrap'>" +
        "<div class='swiper myreferences-swiper'></div>" +
        "<div class='myswiper-navi'>" +
            "<div class='swiper-button-prev myswiper-prev'></div>" +
            "<div class='swiper-button-next myswiper-next'></div>" +
        "</div>" +
    "</div>");

    $slider.find(".myreferences-swiper").append($wrapper);

    if ($block.find(".myreferences-all").length) {
        $slider.insertBefore($block.find(".myreferences-all").first());
    } else {
        $slider.appendTo($block);
    }

    const referencesSwiper = new Swiper($slider.find(".myreferences-swiper")[0], {
        navigation: {
            nextEl: $slider.find(".myswiper-next")[0],
            prevEl: $slider.find(".myswiper-prev")[0],
        },
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 30,
        centerInsufficientSlides: true,
        breakpoints: {
            320: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 40,
            },
            1440: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
            },
            1600: {
                slidesPerView: 5,
                slidesPerGroup: 1,
                spaceBetween: 40,
            },
        },
    });
}

function myReferencesInit() {
    const $blocks = $(".myreferences").not(".is-loaded");

    if ($blocks.length === 0) {
        return;
    }

    $blocks.addClass("is-loaded");

    let cached = null;
    try {
        cached = JSON.parse(sessionStorage.getItem(MYREFERENCES_CACHE_KEY));
    } catch (e) {
        cached = null;
    }

    if (cached && Date.now() - cached.time < MYREFERENCES_CACHE_TTL) {
        $blocks.each(function () {
            myReferencesRender($(this), cached.data);
        });
        return;
    }

    $.get(MYREFERENCES_URL, function (html) {
        const data = myReferencesParse(html);
        try {
            sessionStorage.setItem(MYREFERENCES_CACHE_KEY, JSON.stringify({ time: Date.now(), data: data }));
        } catch (e) {
            // bez sessionStorage se hodnocení jen nenacachují
        }
        $blocks.each(function () {
            myReferencesRender($(this), data);
        });
    }, "html");
}

$(document).ready(myReferencesInit);

// Kategorie a detail: blok vkládá loaders.js z HTML homepage
$(document).ajaxComplete(function (e, xhr, settings) {
    if (settings.url === "/") {
        myReferencesInit();
    }
});
